<template>
    <div class="animated-bg">
        <div 
            v-for="(symbol, index) in chemSymbols" 
            :key="index"
            class="chem-symbol"
            :style="{
                left: symbol.x + 'px',
                top: symbol.y + 'px',
                fontSize: symbol.size + 'px',
                opacity: symbol.opacity
            }"
        >
            {{ symbol.text }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'AnimatedBackground',
    data() {
        return {
            chemSymbols: [],
            mouseX: 0,
            mouseY: 0,
            scrollY: 0,
            lastScrollY: 0,
            animationFrame: null,
            symbols: [
                'H₂O', 'CO₂', 'NH₃', 'CH₄', 'O₂', 'N₂', 'H⁺', 'OH⁻', 'Na⁺', 'Cl⁻', 
                'C₆H₁₂O₆', 'NaCl', 'H₂SO₄', 'HCl', 'CaCO₃', 'Fe²⁺', 'Cu²⁺', 'SO₄²⁻',
                'NO₃⁻', 'PO₄³⁻', 'CH₃COOH', 'C₂H₅OH',
                'ΔH', 'ΔG', 'ΔS', 'Kₑq', 'pH', 'pKₐ', 'ΔH°', 'ΔG°', 'Ka', 'Kb',
                'E°', '[H⁺]', '[OH⁻]', 'n=m/M', 'c=n/V', 'PV=nRT', 'Q=mcΔT'
            ]
        };
    },
    mounted() {
        this.initSymbols();
        this.animate();
        
        window.addEventListener('mousemove', this.handleMouseMove);
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeUnmount() {
        window.removeEventListener('mousemove', this.handleMouseMove);
        window.removeEventListener('scroll', this.handleScroll);
        if (this.animationFrame) {
            cancelAnimationFrame(this.animationFrame);
        }
    },
    methods: {
        initSymbols() {
            const symbolCount = 30;
            const pageHeight = Math.max(document.documentElement.scrollHeight, 4000);
            
            for (let i = 0; i < symbolCount; i++) {
                this.chemSymbols.push({
                    text: this.symbols[Math.floor(Math.random() * this.symbols.length)],
                    x: Math.random() * window.innerWidth,
                    y: Math.random() * pageHeight,
                    vx: (Math.random() - 0.5) * 0.8,
                    vy: (Math.random() - 0.5) * 0.8,
                    size: 20 + Math.random() * 30,
                    opacity: 0.15 + Math.random() * 0.25
                });
            }
        },
        animate() {
            const pageHeight = Math.max(document.documentElement.scrollHeight, 4000);
            
            this.chemSymbols.forEach(symbol => {
                // Update position
                symbol.x += symbol.vx;
                symbol.y += symbol.vy;

                // Mouse interaction
                const dx = this.mouseX - symbol.x;
                const dy = this.mouseY - symbol.y;
                const distance = Math.sqrt(dx * dx + dy * dy);
                
                if (distance < 150) {
                    const force = (150 - distance) / 150;
                    symbol.x -= dx * force * 0.03;
                    symbol.y -= dy * force * 0.03;
                }

                // Scroll interaction
                symbol.y -= this.scrollY * 0.2;

                // Boundary collision
                if (symbol.x < -50) {
                    symbol.x = window.innerWidth + 50;
                } else if (symbol.x > window.innerWidth + 50) {
                    symbol.x = -50;
                }
                
                if (symbol.y < -50) {
                    symbol.y = pageHeight + 50;
                } else if (symbol.y > pageHeight + 50) {
                    symbol.y = -50;
                }
            });
            
            this.scrollY *= 0.8;
            this.animationFrame = requestAnimationFrame(this.animate);
        },
        handleMouseMove(e) {
            this.mouseX = e.clientX;
            this.mouseY = e.clientY;
        },
        handleScroll() {
            this.scrollY = window.scrollY - this.lastScrollY;
            this.lastScrollY = window.scrollY;
        }
    }
};
</script>

<style scoped>
.animated-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    pointer-events: none;
    z-index: 1;
    overflow: visible;
}

.chem-symbol {
    position: absolute;
    color: var(--text-secondary);
    font-weight: 300;
    pointer-events: none;
    user-select: none;
    will-change: transform;
}
</style>